import React from 'react';

import BlogIcon from './icons/blog.svg?react';
import CatalogIcon from './icons/catalog.svg?react';
import DocsIcon from './icons/docs.svg?react';
import ForumIcon from './icons/forum.svg?react';
import TgChannelIcon from './icons/tg_channel.svg?react';
import TgChatIcon from './icons/tg_chat.svg?react';
import VkIcon from './icons/vk.svg?react';

const icons = {
  shop: CatalogIcon,
  blog: BlogIcon,
  docs: DocsIcon,
  forum: ForumIcon,
  vk: VkIcon,
  channel: TgChannelIcon,
  group: TgChatIcon,
};

export default function NavigationIcon({ name, className }) {
  const Icon = icons[name];

  if (!Icon) {
    return null;
  }

  return <Icon className={className} aria-hidden="true" focusable="false" />;
}
